<template>
<div>
  <form class="profile-form">
    <div class="field is-horizontal">
      <div class="field-body">
        <text-field label="Company name" v-model.trim="companyName" :error="companyNameError" />
        <text-field label="Company URL" v-model.trim="companyDomain" />
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-body">
        <text-field label="Company category" v-model.trim="category" />
        <location-field label="Company location" v-model="location" />
      </div>
    </div>
    <div class="field">
      <label>{{this.$t('profile.shortBio')}} • {{ bioLengthText }}</label>
      <div class="control">
      <textarea :class="getbioClass" :placeholder="this.$t('profile.somethingAboutUrself')"
                v-model="bio">
      </textarea>
        <p class="help is-danger" v-if="bioError">{{bioError}}</p>
      </div>
    </div>
  </form>
  <hirer-autocomplete :label="companyJobLabel" v-model="companyJobsBoard"></hirer-autocomplete>
</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'
import LocationField from '@/components/general/location-autocomplete-field'
import TagSelect from '@/components/general/tag-select'
import HirerAutocomplete from '@/components/signup/hirer-autocomplete'

export default {
  components: { Field, TextField, LocationField, TagSelect, HirerAutocomplete },
  props: {
    showOptional: {
      type: Boolean,
      default: false
    },
    bioError: {
      type: String
    }
  },
  data () {
    return {
      nameError: null
    }
  },
  computed: {
    ...mapState('hirerProfileForm', {
      formBio: 'bio',
      formCompanyName: 'companyName',
      formCompanyDomain: 'companyDomain',
      formCategory: 'category',
      formCompanyJobBoard: 'companyJobsBoard',
      companyNameError: 'companyNameError'
    }),
    ...mapGetters('hirerProfileForm', {
      formLocation: 'location'
    }),
    getbioClass () {
      return this.bioError ? 'textarea is-danger' : 'textarea'
    },
    companyJobLabel () {
      return this.$t('profile.joinCompany')
    },
    footerText () {
      return this.$t('profile.yourRequest')
    },
    bioLengthText () {
      return `${this.bioLength} of ${this.bioMaxLength}`
    },
    bioLength () {
      if (this.bio) {
        return this.bio.length
      } else {
        return 0
      }
    },
    bioMaxLength () {
      return 350
    },
    bio: {
      get () { return this.formBio },
      set (value) { this.setBio(value) }
    },
    companyName: {
      get () { return this.formCompanyName },
      set (value) { this.setCompanyName(value) }
    },
    companyDomain: {
      get () { return this.formCompanyDomain },
      set (value) { this.setCompanyDomain(value) }
    },
    location: {
      get () { return this.formLocation },
      set (value) { this.setLocation(value) }
    },
    category: {
      get () { return this.formCategory },
      set (value) { this.setCategory(value) }
    },
    companyJobsBoard: {
      get () { return this.formCompanyJobBoard },
      set (value) { this.setCompanyJobsBoard(value) }
    }
  },
  watch: {
    bio (newValue, oldValue) {
      if (newValue.length > this.bioMaxLength) {
        this.bio = oldValue
      }
    }
  },
  methods: {
    ...mapMutations('hirerProfileForm', [
      'setBio',
      'setCompanyName',
      'setCompanyDomain',
      'setLocation',
      'setCategory',
      'setCompanyJobsBoard'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";

.right-label {
  color: rgba(17, 17, 17, 0.2);
  float: right;
}

.field.is-spaced {
  margin-top: 0;
}

.field.is-horizontal {
  margin-bottom: 0;
}

@media screen and (max-width: $tablet) {
  .field.is-horizontal {
    margin-bottom: 1.5rem;
  }
}
.marginTop{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/signup/hirer-form.vue